module.exports = __webpack_public_path__ + "static/media/statistics-desktop-left-btm-bg.c6518acc.svg";